import { useParams } from "react-router-dom";
import { SearchX } from "lucide-react";

import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/empty-state";
import { DetailSkeleton } from "@/components/loading-skeletons";
import { PageHeader } from "@/components/layout/page-header";
import { WidgetForm } from "@/components/widget/widget-form";
import { useWidgetQuery } from "@/hooks/use-widgets";
import { useTemplateQuery } from "@/hooks/use-templates";

const BREADCRUMBS = [{ label: "Widgets", to: "/widgets" }];

export function EditWidgetPage() {
  const { id } = useParams<{ id: string }>();
  const {
    data: widget,
    isLoading: widgetLoading,
    error: widgetError,
    refetch: refetchWidget,
  } = useWidgetQuery(id!);
  const {
    data: template,
    isLoading: templateLoading,
    error: templateError,
  } = useTemplateQuery(widget?.template_id || "");

  const isLoading = widgetLoading || templateLoading;
  const hasError = widgetError || templateError;

  if (isLoading) {
    return (
      <div className="flex flex-1 flex-col gap-6">
        <PageHeader breadcrumbs={BREADCRUMBS} title="Edit Widget" />
        <DetailSkeleton withTitle={false} />
      </div>
    );
  }

  if (hasError || !widget || !template) {
    return (
      <div className="flex flex-1 flex-col gap-6">
        <PageHeader breadcrumbs={BREADCRUMBS} title="Edit Widget" />
        <EmptyState
          icon={SearchX}
          title="Widget Not Found"
          description="The widget you are trying to edit does not exist."
        >
          <Button variant="outline" size="sm" onClick={() => refetchWidget()}>
            Retry
          </Button>
        </EmptyState>
      </div>
    );
  }

  return <WidgetForm mode="edit" widget={widget} template={template} />;
}
